// extracted by mini-css-extract-plugin
export default {"menuIcon":"HeaderMenu_menuIcon__8BtBX","menu":"HeaderMenu_menu__Uhk8P","icon":"HeaderMenu_icon__8CbKI"};